import { Inject, Injectable, LOCALE_ID, NgModule, Optional } from '@angular/core';
import { NB_DATE_SERVICE_OPTIONS, NbDateService, NbNativeDateService } from '@nebular/theme';
import parse from 'date-fns/parse';
import formatDate from 'date-fns/format';
import getWeek from 'date-fns/getWeek';

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import * as ɵngcc0 from '@angular/core';
class NbDateFnsDateService extends NbNativeDateService {
    constructor(locale, options) {
        super(locale);
        this.options = options || {};
    }
    format(date, format) {
        if (date) {
            return formatDate(date, format || this.options.format, this.options.formatOptions);
        }
        return '';
    }
    parse(date, format) {
        return parse(date, format || this.options.format, new Date(), this.options.parseOptions);
    }
    getId() {
        return 'date-fns';
    }
    getWeekNumber(date) {
        return getWeek(date, this.options.getWeekOptions);
    }
    getDateFormat() {
        return 'YYYY-MM-dd';
    }
}
NbDateFnsDateService.ɵfac = function NbDateFnsDateService_Factory(t) { return new (t || NbDateFnsDateService)(ɵngcc0.ɵɵinject(LOCALE_ID), ɵngcc0.ɵɵinject(NB_DATE_SERVICE_OPTIONS, 8)); };
NbDateFnsDateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NbDateFnsDateService, factory: NbDateFnsDateService.ɵfac });
NbDateFnsDateService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [NB_DATE_SERVICE_OPTIONS,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NbDateFnsDateService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NB_DATE_SERVICE_OPTIONS]
            }] }]; }, null); })();

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
const dateFnsServiceProvider = { provide: NbDateService, useClass: NbDateFnsDateService };
class NbDateFnsDateModule {
    static forRoot(options) {
        return {
            ngModule: NbDateFnsDateModule,
            providers: [
                dateFnsServiceProvider,
                { provide: NB_DATE_SERVICE_OPTIONS, useValue: options },
            ],
        };
    }
    static forChild(options) {
        return {
            ngModule: NbDateFnsDateModule,
            providers: [
                dateFnsServiceProvider,
                { provide: NB_DATE_SERVICE_OPTIONS, useValue: options },
            ],
        };
    }
}
NbDateFnsDateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NbDateFnsDateModule });
NbDateFnsDateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NbDateFnsDateModule_Factory(t) { return new (t || NbDateFnsDateModule)(); }, providers: [dateFnsServiceProvider] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NbDateFnsDateModule, [{
        type: NgModule,
        args: [{
                providers: [dateFnsServiceProvider]
            }]
    }], null, null); })();

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NbDateFnsDateService, NbDateFnsDateModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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